import { isString } from "util";

export function capitalizeFirstLetter(s) {
    if(!isString(s)) {
        throw new Error("ArgumentError: s is not a string");
    }
    return s.charAt(0).toUpperCase() + s.slice(1);
}

export function hyphenSeparationToCamelCase(s, FirstLetterToCapital = true) {
    if(!isString(s)) {
        throw new Error("ArgumentError: s is not a string");
    }
    const retval = s.replace(/-([a-z])/g, function (g) { return g[1].toUpperCase(); });
    if (FirstLetterToCapital) {
        return capitalizeFirstLetter(retval);
    } else {
        return retval;
    }
}


export const formatString = function(str) {
    let formatted = str;
    
    for( const arg in arguments ) {
        if (arg == 0) {
            continue;
        }
        formatted = formatted.replace("{" + (arg-1) + "}", arguments[arg]);
    }
    return formatted;
};